import { CreateProductUpdateSubscriptionsDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateProductUpdatesSubscriptions = () => {
  const [createSubscription, { loading, called }] = useMutation(
    CreateProductUpdateSubscriptionsDocument,
    {
      extractorFn: (data) => data.productUpdatesMutations.createProductupdatesSubscription,
    }
  )

  return {
    loading,
    called,
    createSubscription,
  }
}
